module.exports = "/dist/images/5f43c0ddd82d00ae3c1bd0f055b8eadf-loading.gif";